import { Controller } from 'stimulus';

class AutoOpenPopupController extends Controller {
  connect() {
    this.storageKey = `modal_${this.data.get('storage-key')}`;

    const time = window.localStorage.getItem(this.storageKey);

    if (time) {
      const currentTime = Date.now();
      const diffTimeSeconds = (currentTime - time) / 1000;

      const hourInSeconds = 60 * 60;

      if (diffTimeSeconds < hourInSeconds) {
        return;
      }
    }

    $(this.element).modal('show');

    $(this.element).on('hidden.bs.modal', this.onHideModal.bind(this));
  }

  disconnect() {
    $(this.element).on('hidden.bs.modal', this.onHideModal.bind(this));
  }

  onHideModal() {
    window.localStorage.setItem(this.storageKey, Date.now());
  }
}

AutoOpenPopupController.targets = [
  //
];

export default AutoOpenPopupController;
